import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useLang } from '../context/LanguageContext';
import { HERO_IMAGES } from '../data/mock';
import Reveal from '../components/Reveal';

const About = () => {
  const { t } = useLang();

  return (
    <div className="bg-[#f4efe6]">
      {/* banner */}
      <section className="relative pt-40 pb-20 md:pt-48 md:pb-24 overflow-hidden">
        <div className="absolute inset-0">
          <img src={HERO_IMAGES.geneva2} alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-[#1b2331]/72" />
        </div>
        <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10">
          <p className="font-sans-elegant text-[0.7rem] tracking-brand text-[#c8a469] mb-5">{t('nav.about')}</p>
          <h1 className="font-serif-display text-4xl md:text-6xl text-[#f4efe6] font-light leading-tight">{t('about.title')}</h1>
          <p className="font-serif-display italic text-xl md:text-2xl text-[#f4efe6]/80 mt-5">{t('about.lead')}</p>
        </div>
      </section>

      {/* story */}
      <section className="py-24 md:py-32">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
            <div className="lg:col-span-5">
              <Reveal>
                <div className="img-zoom aspect-[3/4]">
                  <img src={HERO_IMAGES.interior} alt="" className="w-full h-full object-cover" />
                </div>
              </Reveal>
            </div>
            <div className="lg:col-span-7 lg:pt-8">
              <Reveal delay={120}>
                <div className="hairline w-16 mb-8" />
                <p className="font-serif-display text-2xl md:text-3xl text-[#1b2331] font-light leading-relaxed mb-8">
                  {t('about.p1')}
                </p>
                <p className="font-sans-elegant text-[#5a5d63] leading-relaxed text-lg">
                  {t('about.p2')}
                </p>
              </Reveal>
            </div>
          </div>
        </div>
      </section>

      {/* mission */}
      <section className="relative py-28 md:py-36 overflow-hidden">
        <div className="absolute inset-0">
          <img src={HERO_IMAGES.parisGolden} alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-[#1b2331]/82" />
        </div>
        <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10 text-center">
          <Reveal>
            <p className="font-sans-elegant text-[0.7rem] tracking-brand text-[#c8a469] mb-8">
              {t('about.missionTitle')}
            </p>
            <p className="font-serif-display text-3xl md:text-5xl text-[#f4efe6] font-light leading-tight max-w-4xl mx-auto">
              {t('about.mission')}
            </p>
          </Reveal>
        </div>
      </section>

      {/* regions strip */}
      <section className="py-20 bg-[#eae2d3]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-[#1b2331]/15">
            {['France', 'Suisse', 'International'].map((r, i) => (
              <Reveal key={r} delay={i * 100}>
                <div className="bg-[#eae2d3] py-12 text-center">
                  <p className="font-serif-display text-4xl md:text-5xl text-[#1b2331]">{r}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <div className="text-center mt-16">
            <Link
              to="/contact"
              className="group inline-flex items-center gap-3 bg-[#1b2331] text-[#f4efe6] font-sans-elegant text-xs tracking-wide-2 uppercase px-10 py-4 hover:bg-[#b0894f] transition-colors"
            >
              {t('cta.button')}
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
